// Fixes this issue http://stackoverflow.com/questions/17702401/ie-8-selecting-n1-index when applied to <select>

var module = angular.module('octopusApp.infrastructure');

module.directive('fixIeSelect', function($timeout, sniffer){
  return {
    require:'select',
    link: function (scope, element) {
      if(sniffer.isIE){
        $timeout(function(){
          var dummy = angular.element('<option disabled></option>');
          element.append(dummy);
        });
      }
    }
  };
});





//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/fix_ie_select.js
// module id = 5958484718457688
// module chunks = 1